/**
 * Validador para números de telefone internacionais
 * Usa a biblioteca intl-tel-input para validação
 */

export const phoneValidator = (_, value) => {
	// Se não há valor, não é obrigatório (deixar para o required do Form.Item)
	if (!value || !value.target) {
		return Promise.resolve();
	}

	const { isValid, value: phoneNumber } = value.target;

	// Se o valor está vazio, não é obrigatório
	if (!phoneNumber || phoneNumber.trim() === "") {
		return Promise.resolve();
	}

	// Validação usando a biblioteca intl-tel-input
	// Se isValid é true, aceita
	if (isValid === true) {
		return Promise.resolve();
	}

	// Se isValid é false, rejeita
	if (isValid === false) {
		return Promise.reject(new Error("Número de telefone inválido"));
	}

	// Se isValid é undefined/null, aceita (deixa para validação obrigatória)
	// Isso evita conflitos durante a digitação
	return Promise.resolve();
};

/**
 * Validador obrigatório para telefone
 */
export const requiredPhoneValidator = (_, value) => {
	// Verifica se há valor
	if (!value) {
		return Promise.reject(new Error("Telefone é obrigatório"));
	}

	// Usar estado global de validação se disponível
	if (window.phoneValidationState) {
		const { isValid, phoneNumber } = window.phoneValidationState;

		// Verifica se o número está vazio
		if (!phoneNumber || phoneNumber.trim() === "") {
			return Promise.reject(new Error("Telefone é obrigatório"));
		}

		// Validação obrigatória - só aceita se for explicitamente válido
		if (isValid === true) {
			return Promise.resolve();
		}

		// Se não é válido ou está undefined, rejeita
		return Promise.reject(new Error("Número de telefone inválido"));
	}

	// Fallback: Se value é um objeto com target (nossa estrutura customizada)
	if (value && value.target) {
		const { value: phoneNumber, isValid } = value.target;

		// Verifica se o número está vazio
		if (!phoneNumber || phoneNumber.trim() === "") {
			return Promise.reject(new Error("Telefone é obrigatório"));
		}

		// Validação obrigatória - só aceita se for explicitamente válido
		if (isValid === true) {
			return Promise.resolve();
		}

		// Se não é válido ou está undefined, rejeita
		return Promise.reject(new Error("Número de telefone inválido"));
	}

	// Se value é uma string (valor direto do Ant Design)
	if (typeof value === "string") {
		// Verifica se o número está vazio
		if (!value || value.trim() === "") {
			return Promise.reject(new Error("Telefone é obrigatório"));
		}

		// Para validação básica, verifica se tem pelo menos 10 dígitos
		const digitsOnly = value.replace(/\D/g, "");
		if (digitsOnly.length >= 10) {
			return Promise.resolve();
		}

		return Promise.reject(new Error("Número de telefone inválido"));
	}

	return Promise.reject(new Error("Telefone é obrigatório"));
};

/**
 * Função para extrair apenas o número do telefone (sem formatação)
 */
export const extractPhoneNumber = (value) => {
	if (!value || !value.target) {
		return "";
	}

	const { value: phoneNumber } = value.target;
	return phoneNumber || "";
};

/**
 * Função para obter informações do telefone
 */
export const getPhoneInfo = (value) => {
	if (!value || !value.target) {
		return null;
	}

	return {
		phoneNumber: value.target.value,
		isValid: value.target.isValid,
		countryCode: value.target.countryCode,
		countryName: value.target.countryName,
	};
};
